(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbContentUploadDataStore', ['$http', '$q', 'gettextCatalog', 'sbToastService', 'smbContentUploadService', ContentUploadDataStore]);
	
	/**
	 * @ngdoc service
	 * @name smb-app.smbContentUploadDataStore
	 * 
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function ContentUploadDataStore($http, $q, gettextCatalog, sbToastService, smbContentUploadService) {
		var _uploadedDocument = null;
		var _uploadHandlers = [];

		return {

			get uploadedDocument() {
				return _uploadedDocument;
			},
			
			uploadDocument: uploadDocument,

			/**
			 * @ngdoc method
			 * @name smbContentUploadDataStore#onUploadSuccess
			 * @methodOf smb-app.smbContentUploadDataStore
			 * @kind function
			 * 
			 * @description
			 * Add a function that gets called when a file is successfully uploaded.
			 * 
			 * @param {Function} handler The function to be called when a file is uploaded
			 * @returns {Function} A function that can be called to remove your handler.
			 * 
			 * @example
			 *     function SomeController($scope, smbContentUploadDataStore) {
			 *         var removeHandler = smbContentUploadDataStore.onUploadSuccess(function() {
			 *             console.log('uploaded a new file');
			 *         });
			 * 		   $scope.$on('$destroy', function() {
			 *             removeHandler();
			 *         });
			 *     }
			 */
			onUploadSuccess: onUploadSuccess,

			/**
			 * @ngdoc method
			 * @name smbContentUploadDataStore#uploadRevision
			 * @methodOf smb-app.smbContentUploadDataStore
			 * @kind function
			 * 
			 * @description
			 * Upload a file as a new revision for an existing document
			 * 
			 * @param {Number} documentId Id of the document that gets the new revision
			 * @param {Object} file Browser file object for the file to upload.
			 * 
			 * @returns {Deferred} A promise
			 */
			uploadRevision: uploadRevision,

			/**
			 * @ngdoc method
			 * @name smbContentUploadDataStore#promoteRevision
			 * @methodOf smb-app.smbContentUploadDataStore
			 * @kind function
			 * 
			 * @description
			 * Promote a document revision to the current revsion
			 * This will be treated as an uploaded file, therefore the upload handlers will be executed on success.
			 * 
			 * @param {Object} revision The revision object to promote
			 * @returns {Deferred} A promise that resolves to the document that was saved as the current revision.
			 */
			promoteRevision: promoteRevision
		};

		function onUploadSuccess(handler) {
			if (typeof handler !== 'function') {
				return;
			}

			_uploadHandlers.push(handler);
			return function() {
				var i = _uploadHandlers.indexOf(handler);
				_uploadHandlers.splice(i, 1);
			};
		}

		function uploadRevision(documentId, file) {
			return smbContentUploadService.uploadRevision(documentId, file)
				.then(function(res) {
					_uploadedDocument = res;
					_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
					return _uploadedDocument;
				});
		}

		function uploadDocument(folderId, file) {
			return smbContentUploadService.uploadFile(folderId, file)
			.then(function(response) {
				_uploadedDocument = response;
				_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
				return _uploadedDocument;
			})
			.catch(function(err) {
				sbToastService.showSimple(err.data.Message);
			});
		}

		function promoteRevision(document) {
			return $http.post(document.Links.PromoteUri)
				.then(function(response) {
					_uploadedDocument = response;
					_uploadHandlers.forEach(function(handler) { handler(_uploadedDocument); });
					return _uploadedDocument;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentUploadDataStore.js
// module id = 117
// module chunks = 1